<template>
	<div>
		<h1 class="vrnu-headline">Kunden</h1>
    <vrnu-text-box v-bind:variant="'info'">
      Über die Gutscheinverwaltung können Kunden wahlweise einzeln oder listenweise angelegt, bearbeitet und gelöscht werden.
      Ein Kunde ist ein App-Benutzer, der einen speziellen Authentifizierungscode benötigt, um Daten vom Server zu lesen.
      Dieser Code (Identifikator) ist eine Kombination aus seinem Geburtsdatum und seiner IBAN.
    </vrnu-text-box>
    <b-button 	v-if="$auth.check(['user', 'superadmin'])"
					class="vrnu-button"
					v-on:click="openUploadModal"><span class="icon-plus-circled"></span>&nbsp;&nbsp;Kundenliste hochladen</b-button>
    <div class="space10"></div>
		<vrnu-list-wizard 	v-bind:listData="listData"
							v-on:delete="deleteCustomer"
							v-on:saveSuccess="saveSuccess"
							v-on:saveError="saveError"></vrnu-list-wizard>

		<!-- Info modal -->
		<b-modal ref="infoModal" centered hide-footer title="Info">
			<p>{{ infoModalMessage }}</p>
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="$refs.infoModal.hide()">Ok</b-button>
			</slot>
	    </b-modal>	    

		<!-- Upload modal -->
		<b-modal ref="uploadModal" centered hide-footer size="lg" title="Kundenliste hochladen" v-on:hidden="$refs.fileinput.reset();">
		<b-alert show dismissible variant="warning">Beim Hochladen einer neuen Kundenliste werden alle existierenden Kunden gelöscht und mit den neuen Kundendaten überschrieben. Bitte beachten Sie außerdem, dass es sich bei der hochgeladenen Datei um eine .csv-Datei handeln muss, die die Spalte "key" mit den Pseudonymen der Kunden enthält.</b-alert>
			<b-form-group>
				<b-form-file
					id="customerUploadList"
					ref="fileinput"
					placeholder="Kundenliste hochladen"
					v-model.trim="customerUploadList"
					v-bind:state="Boolean(customerUploadList)"
					accept="file/csv">
				</b-form-file>
			</b-form-group>							
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="uploadCustomerList">Hochladen</b-button>
			</slot>
	    </b-modal>	    
	</div>
</template>

<script>
// Organize imports
import ListWizard from '@/components/99_wizards/ListWizard';
import moment from 'moment';

export default {
	data: function() {
		return {
			customers: [],
			customerUploadList: false,
			infoModalMessage: null,
			listData: {
				name: "Kunden",
				confirmAttribute: 'key',
				formModule: 'vrnu-customers-form',
				target: 'customers',
				pagination: true,
				filter: true,
				fields: [
					{
						key: 'key',
						label: 'Identifikator',
						sortable: true,
						formatter: function(value) {
							return value.toString();								
						},
					},
/* 					{
						key: 'birthdate',
						label: 'Geburtsdatum',
						sortable: true,
						formatter: function(value) {
							return moment(value).format("DD.MM.YYYY");								
						},
					},
 */				],
				actions: [
					{
						type: 'update',
						text: 'Kunde bearbeiten',
						icon: 'icon-pencil',
					},
					{
						type: 'delete',
						text: 'Kunde löschen',
						icon: 'icon-trash',
					},
				],
			},
		};
	},
	methods: {
		getCustomers: function() {
			this.$http.get('customers').then(customers => {
				this.customers = customers.body;
			}, response => {
				this.customers = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		deleteCustomer: function(id) {
			this.$http.delete('customers/' + id).then(response => {
				var customerKey = response.body.key;
				this.openInfoModal("Der Kunde \"" + customerKey + "\" wurde erfolgreich gelöscht.");
			}, response => {
				this.openInfoModal("Beim Löschen des Kunden ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
			});
		},
		uploadCustomerList: function() {
			// Upload list to server
			if(this.customerUploadList !== false) {
				// Create a new FormData object
				var data = new FormData();
				data.append("list", this.customerUploadList);

				// Save the image to the server
				this.$http.post('upload/customerList', data).then(result => {					
					// Close and clear modal
					this.customerUploadList = false;
					this.$refs.fileinput.reset();
					this.$refs.uploadModal.hide();
					this.openInfoModal("Die Kundenliste wurde erfolgreich hochgeladen und verarbeitet. Es wurden " + result.body + " Kunden hinzugefügt.");
					
					// Refresh customer list
					this.getCustomers();
				}, response => {
					if(typeof response.body.msg !== 'undefined') {
						this.openInfoModal(response.body.msg);																		
					} else {
						this.openInfoModal("Beim Hochladen der Kundenliste ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");												
					}
					
					// Close and clear modal
					this.customerUploadList = false;
					this.$refs.fileinput.reset();
					this.$refs.uploadModal.hide();
					
					// Refresh customer list
					this.getCustomers();
				});
			}
			
		},
		saveSuccess: function(result) {
			this.openInfoModal("Der Kunde \"" + result.body.key + "\" wurde erfolgreich gespeichert.");
		},
		saveError: function(response) {
			this.openInfoModal("Beim Speichern des Kunden ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
		},
		openInfoModal: function(message) {
			this.infoModalMessage = message;
			this.$refs.infoModal.show();
		},
		openUploadModal: function() {
			this.$refs.uploadModal.show();
		},
	},
	watch: {
		customers: function() {
			this.$forceUpdate();
		},
	},
	computed: {
		moment: function() {
			return moment;
		},
	},
	created: function() {
		// Get coupons from server and display them
		this.getCustomers();
	},
	components: {
		'vrnu-list-wizard': ListWizard,
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/05_customer/Customers.vue